<template>
  <div align="center">
    <p>
      Bienvenido a TCI Software S.A.S, seleccione una de las opciones del menú
      principal, para navegar entre los servicios o productos disponibles.
    </p>
  </div>
  <br />
  <br />
  <br />
  <br />
  <br />
  <v-img class="mx-auto" :width="400" src="/static/iconos/logo1.png"></v-img>
</template>

<script>
export default {
  name: "Inicio",
};
</script>
